import { render, staticRenderFns } from "./right-preview.vue?vue&type=template&id=509663a2&scoped=true&"
import script from "./right-preview.vue?vue&type=script&lang=ts&"
export * from "./right-preview.vue?vue&type=script&lang=ts&"
import style0 from "./right-preview.vue?vue&type=style&index=0&id=509663a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509663a2",
  null
  
)

export default component.exports